module.exports = __webpack_public_path__ + "img/icon_over_manejo_de_parametros_sistema.5be79a25.svg";